
import { Save, Upload as UploadIcon } from 'lucide-react';
import { useFlowSave } from '../hooks/useFlowSave';

const ControlPanel = () => {
  const { saveFlow, loadFlow } = useFlowSave();

  return (
    <div className="absolute top-4 right-4 z-50 flex gap-2 bg-slate-800/90 backdrop-blur border border-slate-700 p-1.5 rounded-lg shadow-xl">
      <button
        onClick={saveFlow}
        className="flex items-center gap-1.5 text-slate-300 text-xs hover:bg-slate-700 hover:text-white px-3 py-1.5 rounded transition-colors"
        title="Export to JSON"
      >
        <Save size={14} />
        <span>Save</span>
      </button>
      <div className="w-[1px] bg-slate-700 my-1"></div>
      <label className="flex items-center gap-1.5 text-slate-300 text-xs hover:bg-slate-700 hover:text-white px-3 py-1.5 rounded cursor-pointer transition-colors" title="Import from JSON">
        <UploadIcon size={14} />
        <span>Load</span>
        <input
          type="file"
          hidden
          accept=".json"
          onChange={(e) => {
            if (e.target.files?.[0]) {
              loadFlow(e.target.files[0]);
              e.target.value = ''; // reset so same file can be loaded again if needed
            }
          }}
        />
      </label>
    </div>
  );
};

export default ControlPanel;